import React, { createContext, useContext, useState } from "react";

export const PlatformBuilderContext = createContext();

export const PlatformBuilderContextProvider = ({ children }) => {
  
  const [inTemplateBuilder, setInTemplateBuilder] = useState(false);
  const [inGlobalNavBuilder, setInGlobalNavBuilder] = useState(false);

  return (
    <PlatformBuilderContext.Provider value={{ inTemplateBuilder, setInTemplateBuilder, inGlobalNavBuilder, setInGlobalNavBuilder }}>
      {children}
    </PlatformBuilderContext.Provider>
  );
};

export const usePlatformBuilderContext = () => {
  return useContext(PlatformBuilderContext);
};
